import { TableHead, TableRow, TableCell, Checkbox } from "@mui/material";

export const EditableTableHead = (props) => {
  const { onSelectAllClick, numSelected, rowCount, headCells } = props;

  return (
    <TableHead>
      <TableRow>
        <TableCell padding="checkbox">
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              "aria-label": "select all desserts",
            }}
          />
        </TableCell>
        {headCells.map((headCell) => (
          <TableCell key={headCell?.id} sortDirection={false} align="center">
            {headCell?.title}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
